<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div>
            <div>
              <div class="card top-draft">
                <div class="col-lg-12 list-header pad-header-bg clearfix">
                  <div class="header-item-fix">
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="pageParams.contentKeyword"
                      placeholder="请输入搜索内容"
                      @keyup.enter.native="search"
                    ></b-form-input>
                    <b-button size="sm" variant="primary" @click="search()">
                      <i
                        class="bx bx-search-alt-2 font-size-16 align-middle"
                      ></i>
                      搜索
                    </b-button>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="resetParams()"
                    >
                      <i class="bx bx-revision font-size-16 align-middle"></i>
                      重置
                    </b-button>
                  </div>
                  <span v-if="isLiveComment">
                    <el-button
                      size="mini"
                      @click="selectComment()"
                      type="primary"
                      :icon="imMsgState ? 'el-icon-loading' : 'el-icon-plus'"
                      :disabled="imMsgState"
                      >添加</el-button
                    >
                    <span style="margin-left: 5px" v-if="imMsgState">
                      发送到群组中
                    </span>
                  </span>
                  <span v-else>
                    <el-button
                      size="mini"
                      @click="selectComment()"
                      type="primary"
                      icon="el-icon-plus"
                      >添加</el-button
                    >
                  </span>
                  <b-button
                    style="margin-left: 10px"
                    size="sm"
                    v-if="isDisclosureComment"
                    variant="primary"
                    @click="toDisclosureReply()"
                  >
                    新建回复
                  </b-button>
                </div>

                <div class="col-lg-12">
                  <div class="table-responsive" v-loading="tableLoading">
                    <table
                      class="table table-nowrap table-centered align-middle table-hover"
                    >
                      <thead>
                        <tr>
                          <th scope="col" style="width: 30px">
                            <b-form-checkbox
                              @change="checkedAll"
                              v-model="indeterminate"
                              checked
                              plain
                            ></b-form-checkbox>
                          </th>
                          <th scope="col" style="width: 70px">ID</th>
                          <th scope="col">标题</th>
                          <th scope="col">作者</th>
                          <th scope="col">审核状态</th>
                          <th scope="col">点赞</th>
                          <th scope="col">日期</th>
                          <th scope="col">热评</th>
                          <th scope="col">操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <td style="width: 30px">
                            <b-form-checkbox
                              v-model="choiceListIds"
                              :value="item.id"
                              checked
                              plain
                            ></b-form-checkbox>
                          </td>
                          <td>{{ item.id }}</td>
                          <td class="w-200 white-inherit">
                            {{ item.message }}
                            <t-icon
                              color="#556ee6"
                              name="attach"
                              v-if="item.attachmentDtoList.length"
                            />
                          </td>
                          <td>{{ item.userName || "--" }}</td>
                          <td>
                            <span v-if="item.verifyState === 0">草稿</span>
                            <span v-if="item.verifyState === 2">驳回</span>
                            <span v-if="item.verifyState === 1">通过</span>
                            <span v-if="item.verifyState === 3">待审核</span>
                          </td>
                          <td>{{ item.likeNum || "0" }}</td>
                          <td>{{ item.updatedAt || "--" }}</td>
                          <td>
                            <span v-if="item.hotState == 0">否</span>
                            <span v-if="item.hotState == 1">是</span>
                          </td>

                          <td>
                            <ul
                              class="list-inline font-size-20 contact-links mb-0"
                            >
                              <li
                                class="list-inline-item px-2"
                                @click="toDetail(item)"
                              >
                                <a v-b-tooltip.hover title="编辑">
                                  <i class="bx bxs-edit"></i>
                                </a>
                              </li>
                              <li
                                class="list-inline-item px-2"
                                @click="toStorage(item)"
                              >
                                <a v-b-tooltip.hover title="入库">
                                  <i class="bx bx-paste"></i>
                                </a>
                              </li>
                              <li
                                class="list-inline-item px-2"
                                @click="remove(item)"
                              >
                                <a v-b-tooltip.hover title="移除">
                                  <i class="bx bx-trash"></i>
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="!items || !items[0]" class="xb-table-noData">
                      <span v-if="!tableLoading && !items[0]">暂无数据</span>
                    </div>
                  </div>
                  <pagination
                    class="bath_r_20"
                    :isBatch="true"
                    :batchs="batchs"
                    :total="pageTotal"
                    :pageSize="pageParams.pageSize"
                    :page.sync="pageParams.page"
                    :pageSizes="[30, 50, 100]"
                    @pageCallback="pageCallback"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <detail @pageCallback="pageCallback" ref="detail"></detail>
      <putStorage @pageCallback="pageCallback" ref="storage"></putStorage>
      <comment-dialog
        @pageCallback="pageCallback"
        ref="comment"
      ></comment-dialog>
      <!-- <disclosure-reply
        @pageCallback="pageCallback"
        ref="disclosureReply"
      ></disclosure-reply> -->
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Vue from "vue";
import Swal from "sweetalert2";
import content from "@/server/api/comments";
import detail from "./detail";
import putStorage from "./putStorage";
import commentDialog from "../commentDialog.vue";
// import liveApi from "@/server/api/live.js";
// import { sendImMsg } from "@/util/imMessage.js";
import { mapGetters } from "vuex";
import { waitTime } from "@/util/fun.js";
import { changeList } from "@/util/fun.js";
// import disclosureReply from "./disclosureReply.vue";
/**
 * Contacts-list component
 */
export default {
  components: {
    Layout,
    detail,
    putStorage,
    commentDialog,
    // disclosureReply,
  },

  data() {
    return {
      choiceListIds: [], //当前所选择的id
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        contentKeyword: "",
      },
      index_id: "",
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "删除", value: "1" },
        { text: "入库", value: "2" },
      ],
      pageTotal: 0,
      groupId: "", //IM群组id
      isLiveComment: false, //代表当前是直播评论页面
      isDisclosureComment: false, //代表是报料评论
      tableLoading: false,
      type: "",
    };
  },

  watch: {
    choiceListIds: function () {
      if (
        this.choiceListIds.length == this.items.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },
  computed: {
    ...mapGetters("variable", ["imMsgState"]),
  },

  created() {
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id;
      this.getList();
    }
    let regArr = ["video", "live", "article", "discuss", "disclosure"];
    let types = ["video", "stream", "article", "discuss", "disclosure"];
    console.log(this.$route);
    let path = this.$route.path.toLowerCase();
    let length = regArr.length;
    for (let i = 0; i < length; i++) {
      if (path.indexOf(regArr[i]) != -1) {
        this.type = types[i];
        if (i == 1) {
          this.isLiveComment = true;
          this.getGroupId();
        } else if (i == 4) {
          this.isDisclosureComment = true;
        }
        console.log("当前类型", regArr[i]);
        break;
      }
    }
    console.log("单一组件");
    // if (this.$route.path == "/liveComments") {
    //   //直播评论需要发送消息到群组
    //   this.isLiveComment = true;
    //   this.getGroupId();
    // } else if (this.$route.path == "/disclosureComments") {
    //   //当前页面为报料评论页面
    //   this.isDisclosureComment = true;
    // }
  },

  methods: {
    selectComment() {
      this.$refs.comment.showModel();
    },
    //获取列表数据
    getList(showLoading) {
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      let params = this.utils.getQuery(this.pageParams);
      params.contentId = this.index_id;
      this.choiceListIds = [];
      content.list(params).then((resp) => {
        if (resp.code === 0 && resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            this.items = resp.data.items;
            this.pageTotal = resp.data.total;
          }
        }
      });
    },
    async getGroupId() {
      await liveApi
        .detail({
          id: this.index_id,
        })
        .then((res) => {
          if (res.code === 0) {
            this.groupId = res.data.stream.streamId + "-hannews";
            // 直播groupId区分环境,汉新闻这边似乎没区分
            // if (env.API_ORIGIN == "MASTER") {
            //   this.groupId += "-online";
            // } else if (env.API_ORIGIN == "PRODUCTION") {
            //   this.groupId += "-production";
            // } else if (env.API_ORIGIN == "RELEASE") {
            //   this.groupId += "-test";
            // } else if (env.API_ORIGIN == "DEVELOP") {
            //   this.groupId += "-dev";
            // }
            console.log("群组id", this.groupId);
          }
        });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "comments") {
        // this.getList();
        let item = obj.item;
        if (item) {
          this.items = this.items.map((tr) => {
            if (tr.id == item.id) {
              return { ...tr, ...item };
            } else {
              return tr;
            }
          });
        }
      }
      if (obj.code === "comment") {
        this.addComment(obj.item);
        //let itemList = obj.item;
        //this.currentComments = this.utils.fn2(itemList);
      }
      if (obj.code === "storage") {
        // this.getList();
        this.choiceListIds = [];
      }
      if (obj.code === "reply") {
        this.getList(false);
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.$refs.storage.showModel(this.choiceListIds, "isBatch");
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
      }
    },
    addComment(items) {
      if (items.length === 0) {
        return;
      }
      let saveData = {
        id: this.index_id,
        type: this.type,
        comments: items, //原本地传给接口让接口取需要的参数
      };
      content.add(saveData).then((resp) => {
        if (resp.code == 0) {
          if (resp.data) {
            if (this.isLiveComment) {
              //直播评论需要发送消息到群组
              this.sendImMessage(resp.data);
            }
          }
          Vue.swal({
            icon: "success",
            title: "添加成功！",
            showConfirmButton: false,
            timer: 1000,
          });
          this.getList(false);
        } else {
          Vue.swal(resp.msg);
        }
      });
    },
    async sendImMessage(items) {
      this.changeImMsgState(true);
      if (!this.groupId) {
        await this.getGroupId();
      }
      let length = items.length;
      let time;
      for (let a = 0; a < length; a++) {
        await sendImMsg({
          groupId: this.groupId,
          userId: items[a].userId,
          message: items[a].message,
        });
        console.log("发完消息", a);
        if (a < length - 1) {
          time = (Math.random() * 10000).toFixed(2);
          time = time > 1000 ? time : 1000;
          await waitTime(time);
        }
      }
      // await sendImMsg({
      //   groupId: this.groupId,
      //   userId: items[0].userId,
      //   message: items.map((tr) => {
      //     return tr.message;
      //   }),
      // });
      this.changeImMsgState(false);
    },
    changeImMsgState(val) {
      this.$store.commit("variable/changeImMsgState", val);
    },
    //去编辑
    toDetail(item) {
      this.$refs.detail.showModel(item);
    },

    toStorage(item) {
      this.$refs.storage.showModel(item);
    },
    //报料新建回复
    toDisclosureReply() {
      this.$refs.disclosureReply.showModel(this.index_id);
    },
    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.contentKeyword = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.items.map((item) => item.id);
      } else {
        this.choiceListIds = [];
      }
    },

    // batchHide() {
    //   Swal.fire({
    //     title: "确定隐藏?",
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#f46a6a",
    //     cancelButtonColor: "#74788d",
    //     confirmButtonText: "隐藏",
    //     cancelButtonText: "取消",
    //   }).then((result) => {
    //     if (result.value) {
    //       let params = {};
    //       params.ids = this.choiceListIds;
    //       content.hide(params).then((resp) => {
    //         if (resp.code == 0) {
    //           Vue.swal({
    //             icon: "success",
    //             title: "隐藏成功！",
    //             showConfirmButton: false,
    //             timer: 1000,
    //           });
    //           this.getList();
    //         } else {
    //           Vue.swal(resp.msg);
    //         }
    //       });
    //     }
    //   });
    // },

    // batchShow() {
    //   Swal.fire({
    //     title: "确定显示?",
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#f46a6a",
    //     cancelButtonColor: "#74788d",
    //     confirmButtonText: "显示",
    //     cancelButtonText: "取消",
    //   }).then((result) => {
    //     if (result.value) {
    //       let params = {};
    //       params.ids = this.choiceListIds;
    //       content.show(params).then((resp) => {
    //         if (resp.code == 0) {
    //           Vue.swal({
    //             icon: "success",
    //             title: "显示成功！",
    //             showConfirmButton: false,
    //             timer: 1000,
    //           });
    //           this.getList();
    //         } else {
    //           Vue.swal(resp.msg);
    //         }
    //       });
    //     }
    //   });
    // },

    // batchRevert() {
    //   Swal.fire({
    //     title: "确定撤稿?",
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#f46a6a",
    //     cancelButtonColor: "#74788d",
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //   }).then((result) => {
    //     if (result.value) {
    //       let params = {};
    //       params.ids = this.choiceListIds;
    //       content.revert(params).then((resp) => {
    //         if (resp.code == 0) {
    //           Vue.swal({
    //             icon: "success",
    //             title: "撤稿成功！",
    //             showConfirmButton: false,
    //             timer: 1000,
    //           });
    //           this.getList();
    //         } else {
    //           Vue.swal(resp.msg);
    //         }
    //       });
    //     }
    //   });
    // },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
              if (this.items.length == params.ids.length) {
                this.getList();
              } else {
                this.pageTotal -= params.ids.length;
                this.items = changeList("delete", this.items, params.ids, "id");
              }
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
  },
};
</script>
